import * as Yup from 'yup'
export const paymentReceipt = Yup.object().shape({
	email: Yup.string().email('Invalid email').required('Email must required'),
	phone: Yup.string().typeError('Phone must be number and must required').required('Phone must required'),
})

export const paymentInfoDifferent = Yup.object().shape({
	amount: Yup.number().typeError('Amount must be number').required('Amount must required'),
	zipCode: Yup.number().typeError('Zip code must be number').required('Zip code must required'),
	name: Yup.string().required('Name must required'),
})


export const paymentInfoFull = Yup.object().shape({
	amount: Yup.number().min(1).required('Amount must required'),
	zipCode: Yup.number().typeError('Zip code must be number').required('Zip code must required'),
	name: Yup.string().required('Name must required'),
	creditCard: Yup.boolean().oneOf([true], 'Field must be complete'),
	cardExpiry: Yup.boolean().oneOf([true], 'Field must be complete'),
	cardCvc: Yup.boolean().oneOf([true], 'Field must be complete'),
})
